export const DOCUMENT_MODAL_TITLE = 'Document'
export const DOCUMENT_MODAL_TITLE_FILE = 'File'
export const DOCUMENT_MODAL_TITLE_THUMBNAIL = 'Thumbnail'
export const DOCUMENT_MODAL_TITLE_NEW = 'New document'
export const DOCUMENT_MODAL_TITLE_NEW_FILE = 'New file'
export const DOCUMENT_MODAL_TITLE_NEW_THUMBNAIL = 'New thumbnail'
